import { getToggles } from 'quick-quote/feature-toggles'
import _ from 'lodash'

export const validateMinTopUpValueRule = (premiumPaymentRange, regularTopUp) => {
  return getToggles().ENEBLE_IWEALTHY_OPTIMISE
    ? regularTopUp >= 0
    : regularTopUp === 0 || regularTopUp >= _.get(premiumPaymentRange, 'min', 0)
}

export const validateMinPremiumValueRule = (premiumPaymentRange, premiumValue) => {
  const minimumPremium = premiumValue === 0 || premiumValue >= _.get(premiumPaymentRange, 'min', 0)
  const maxPremium = _.get(premiumPaymentRange, 'max', 0)
  const maximumPremium = premiumValue <= maxPremium
  return maxPremium === 0 ? minimumPremium : minimumPremium && maximumPremium
}

export const validateSumAssuredRule = ({ min, max }, { sumAssured, annualRegularPremium }) => {
  return sumAssured === 0 || (sumAssured >= annualRegularPremium * min && sumAssured <= annualRegularPremium * max)
}

export const validateMaxRegularTopUpRule = (premiumPaymentRange, { regularTopUp, regularPremium }) => {
  let premiumMultiplier = _.get(premiumPaymentRange, ['max', 'maxRegularPremiumMultiplier'], 1)
  return regularTopUp === 0 || regularTopUp <= premiumMultiplier * regularPremium
}
